export { watcherSaga as assignmentEmbedLinkSaga } from './ducks'
export { default as AssignmentEmbedLink } from './container'
